module.exports = __webpack_public_path__ + "static/sport/logo.efdccc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/logo.png
// module id = zeXz
// module chunks = 0